"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _common = require("react-color/lib/components/common");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var _fonts = require("../../../styles/fonts");
var _ColorCircleBlock = _interopRequireDefault(require("../ColorCircleBlock"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBColorPickerDrawerControls = function HBColorPickerDrawerControls(_ref) {
  var _selectedColor$rgb;
  var selectedColor = _ref.selectedColor,
    onColorTextChange = _ref.onColorTextChange,
    onColorChange = _ref.onColorChange,
    className = _ref.className;
  var pointerStyle = (0, _react.useMemo)(function () {
    return {
      pointer: {
        position: 'absolute',
        top: "".concat(100 - selectedColor.hsv.v, "%"),
        left: "".concat(selectedColor.hsv.s, "%"),
        cursor: 'pointer',
        transform: 'translate(-50%, -50%)'
      }
    };
  }, [selectedColor.hsv.v, selectedColor.hsv.s]);
  return /*#__PURE__*/_react["default"].createElement(InDrawerContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(InDrawerSaturationContainer, null, /*#__PURE__*/_react["default"].createElement(_common.Saturation, {
    color: selectedColor.hsl
    // @ts-ignore
    ,
    hsl: selectedColor.hsl,
    pointer: InDrawerKnob,
    style: pointerStyle,
    hsv: selectedColor.hsv,
    onChange: onColorChange
  })), /*#__PURE__*/_react["default"].createElement(InDrawerColorControls, null, /*#__PURE__*/_react["default"].createElement(InDrawerHueContainer, {
    "aria-label": "Color hue slider"
  }, /*#__PURE__*/_react["default"].createElement(_common.Hue, (0, _extends2["default"])({}, selectedColor, {
    onChange: onColorChange,
    pointer: InDrawerKnobHue
  }))), /*#__PURE__*/_react["default"].createElement(InDrawerSwatchContainer, null, /*#__PURE__*/_react["default"].createElement(_ColorCircleBlock["default"], {
    isSquare: true,
    color: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.rgb,
    alpha: selectedColor === null || selectedColor === void 0 || (_selectedColor$rgb = selectedColor.rgb) === null || _selectedColor$rgb === void 0 ? void 0 : _selectedColor$rgb.a,
    testId: "color-picker-drawer-swatch"
  }), /*#__PURE__*/_react["default"].createElement(InDrawerInputContainer, null, /*#__PURE__*/_react["default"].createElement(_common.EditableInput, {
    label: "hex",
    onChange: onColorTextChange,
    value: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.hex,
    "aria-label": "Color picker input"
  })))));
};
var _default = exports["default"] = HBColorPickerDrawerControls; // -------------------------------- Styles -------------------------------- //
var InDrawerContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerContainer",
  componentId: "sc-x7h3kf-0"
})(["width:100%;border-radius:2px;"]);
var InDrawerKnob = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerKnob",
  componentId: "sc-x7h3kf-1"
})(["display:flex;width:32px;height:32px;border:1px solid ", ";border-radius:50%;background-color:", ";box-shadow:0 1px 6px rgba(0,18,71,0.1),0 1px 3px rgba(0,18,71,0.1);"], _colors["default"].neutral300, _colors["default"].white);
var InDrawerSwatchContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerSwatchContainer",
  componentId: "sc-x7h3kf-2"
})(["display:flex;align-items:center;justify-content:center;gap:16px;width:100%;height:100%;"]);
var InDrawerColorControls = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerColorControls",
  componentId: "sc-x7h3kf-3"
})(["display:flex;flex-direction:column;align-items:center;width:100%;.hue-horizontal{border-radius:10px;}"]);
var InDrawerSaturationContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerSaturationContainer",
  componentId: "sc-x7h3kf-4"
})(["position:relative;height:112px;.vaul-scrollable,.saturation-black{border-radius:6px;}"]);
var InDrawerHueContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerHueContainer",
  componentId: "sc-x7h3kf-5"
})(["position:relative;width:100%;height:20px;margin:24px 0;"]);
var InDrawerKnobHue = (0, _styledComponents["default"])(InDrawerKnob).withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerKnobHue",
  componentId: "sc-x7h3kf-6"
})(["transform:translateY(-5px);"]);
var InDrawerInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerDrawerControls__InDrawerInputContainer",
  componentId: "sc-x7h3kf-7"
})(["position:relative;width:100%;margin:0;input{width:100%;height:44px;border-radius:4px;padding:11px 16px;color:", ";background-color:", ";", ";border:none;}label{display:none;}"], _colors["default"].neutral700, _colors["default"].neutral200, _fonts.proximaNova);
//# sourceMappingURL=HBColorPickerDrawerControls.js.map